module.exports = __webpack_public_path__ + "static/media/hero-home-temp.0bf3c082.jpg";